import { queryList } from '@pm-tool/shared';
import { z } from 'zod';

/** URL state of "Wer kann was?"; invalid values are dropped one by one. */
export type PeopleSkillsSearch = { skills?: string[]; area?: string; role?: string };

const fieldSchemas = {
  skills: queryList(z.uuid()).refine((ids) => ids.length > 0),
  area: z.uuid(),
  role: z.uuid(),
};

export function parsePeopleSkillsSearch(raw: Record<string, unknown>): PeopleSkillsSearch {
  const result: PeopleSkillsSearch = {};
  const skills = fieldSchemas.skills.safeParse(raw.skills);
  if (skills.success) result.skills = skills.data;
  const area = fieldSchemas.area.safeParse(raw.area);
  if (area.success) result.area = area.data;
  const role = fieldSchemas.role.safeParse(raw.role);
  if (role.success) result.role = role.data;
  return result;
}
